module.exports = __webpack_public_path__ + "static/img/filter.cacce8d9.svg";